// CONSTANTS are all caps.
const NS = "NewsTemplate";
const CLS = "newsTemplate";
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/newsTemplate.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import utils from '../utils';

export class NewsTemplate {

	constructor($el) {
		// $el is the widget node return by the loadNewsTemplate function
		this.$el = $($el);
	}

	init() {
		this.handleImageCaption();
		this.checkContainer();
		this.initAffix();
		$(window).resize(() => {
			const img = this.$el.find(`${WG}image`);
			img.trigger("sticky_kit:detach");
			$(img).removeAttr('style');
			img.trigger("sticky_kit:recalc");
			this.handleImageCaption();
			this.checkContainer();
			this.initAffix();
		});
	}

	initAffix() {
		const img = this.$el.find(`${WG}image`);

		if(utils.checkBP('dm', true)) {
			let leftOffset = img.offset().left;
			img.stick_in_parent({
				parent: '.newsTemplate-wrapper',
				offset_top: 100
			})
				.on("sticky_kit:stick", function(e) {
					$(e.target).css({
						left: leftOffset+'px'
					});
				})
				.on("sticky_kit:unbottom", function(e) {
					$(e.target).css({
						left: leftOffset+'px'
					});
				})
				.on("sticky_kit:bottom", function(e) {
					$(e.target).css({
						left: 0
					});
				});

			$(window).on('scroll', function(e) {
				if(!img.hasClass('is_stuck')) {
					img.css({
						left: 0
					});
				}
			})
		}
	}

	handleImageCaption() {
		let $wg = this.$el;
		let imgW = $wg.find(`${WG}imageImg`).outerWidth();

		$wg.find(`${WG}imageCaption`).css('width', `${imgW}px`);
	}

	//check if image is bigger than container
	checkContainer() {
		let $wg = this.$el;
		let $wrapper = $wg.find(`${WG}wrapper`);

		if (utils.checkBP('dm', true)) {
			let imageH = $wg.find(`${WG}image`).outerHeight();
			let contH = $wg.find(`${WG}container`).outerHeight();

			$wrapper.css({
				minHeight: imageH > contH ? `${imageH + 100}px` : ''
			});
		} else {
			$wrapper.css('min-height', '');
		}
	}
}
